import { Component, Input } from '@angular/core';
import { convertToAESTDateTime } from 'src/app/shared/utils';

@Component({
    selector: 'app-site-alert',
    templateUrl: './site-alert.component.html',
    styleUrls: ['./site-alert.component.scss'],
})
export class SiteAlertComponent {
    @Input() title: string;
    @Input() description: string;
	@Input() target : string;
    @Input() lastUpdatedDt : string;

    //check if target has a value

    targetSupplied() {
        if (this.target) {
            return true;
        } else {
            return false;
        }
    }

    getLastUpdatedDate = () => {
        const dt = convertToAESTDateTime(this.lastUpdatedDt);
        
        return dt;
        
    }
}
